import React, { Component, useState, useEffect, useRef, useLayoutEffect } from 'react'

import { Link, useNavigate, useLocation } from "react-router-dom"

import Google from '../media/GoogleLogo.png'
import Logo from '../media/FullLogo.png'

import Notification from '../elements/Notification'

//THINGS YOU NEED TO DEFINE FOR THIS TO WORK
{/*
- Add Notification to /elements folder
- Add LoginTemplate to app.js routing
- define window.baseURL
- define window.apiRequest
- define window.colors.white
- define window.getServerResponse
- '../media/GoogleLogo.png' with google logo
- '../media/FullLogo.png' with application URL
- define afterLoginURL to tell where to send user after login
- define afterResetURL to tell where to send user after reset password
- Change colors if wanted
- @import url('https://fonts.googleapis.com/css2?family=Inter:slnt,wght@-10..0,100..900&display=swap'); Needs to be added to CSS
*/}

const colors = {
    //ALL COLORS MUST BE IN HEX CODE
    //CORE COLORS
    fontColor: '#000000',
    backgroundColor: '#FFFFFF',
    primary: '#43dc80',

    //DERIVED COLORS, can be overwritten though if you want to.
    mutedColor: '',
    primaryAccent: ''
}

//where to send them after successful login
const afterLoginURL = '/'

//where to send them after successful password reset
const afterResetURL = '/login'

//where to send them when clicking on logo
const logoURL = '/login'

{/*Helper Fuctions*/}
function lightenColor(color, percent) {
    const num = parseInt(color.slice(1), 16),
          amt = Math.round(2.55 * percent),
          R = (num >> 16) + amt,
          G = (num >> 8 & 0x00FF) + amt,
          B = (num & 0x0000FF) + amt;

    return '#' + (
      0x1000000 + 
      (R < 255 ? R < 1 ? 0 : R : 255) * 0x10000 + 
      (G < 255 ? G < 1 ? 0 : G : 255) * 0x100 + 
      (B < 255 ? B < 1 ? 0 : B : 255)
    ).toString(16).slice(1).toUpperCase();
}

function calculateLuminance(r, g, b) {
    const a = [r, g, b].map(function(v) {
      v /= 255;
      return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
}
  
function bestGrayscaleColorForText(bgColor) {
    const r = parseInt(bgColor.slice(1, 3), 16);
    const g = parseInt(bgColor.slice(3, 5), 16);
    const b = parseInt(bgColor.slice(5, 7), 16);
  
    const luminance = calculateLuminance(r, g, b);
    
    const whiteLuminance = 1; // Luminance of white
    const blackLuminance = 0; // Luminance of black
  
    const whiteContrast = (whiteLuminance + 0.05) / (luminance + 0.05);
    const blackContrast = (luminance + 0.05) / (blackLuminance + 0.05);
  
    return whiteContrast >= 4.5 ? '#FFFFFF' : '#000000';
}

function getCurrentTimeFormatted() {
    const now = new Date();

    let hours = now.getHours();
    const ampm = hours >= 12 ? 'PM' : 'AM';

    hours = hours % 12; // Convert to 12-hour format
    hours = hours ? hours : 12; // The hour '0' should be '12'

    const minutes = now.getMinutes().toString().padStart(2, '0');
    const seconds = now.getSeconds().toString().padStart(2, '0');

    return `${hours.toString().padStart(2, '0')}:${minutes}:${seconds} ${ampm}`;
}
{/*End Helper Fuctions*/}

colors.primaryAccent = colors.primaryAccent === '' ? bestGrayscaleColorForText(colors.primary):colors.primaryAccent
colors.mutedColor = colors.mutedColor === '' ? lightenColor(colors.fontColor, 50):colors.mutedColor

const LoginPage = (props) => {

    if (props.keyValue)
    {
        props.setStage(1)
    }

    const [data, setData] = useState({
        username: '',
        password: '',
        remember_me: false,
    })

    const [notification, setNotification] = useState('')

    const changeData = (value, key) => {
        setData((data) => ({...data, [key]: value}))
    }

    const clickGoogle = (inputData) => {
        //do special stuff here
    }

    const clickLogin = (inputData) => {
        const formData = new URLSearchParams();
        formData.append("username", inputData.username);
        formData.append("password", inputData.password)

        fetch(window.baseURL + '/auth/login', {
            method: "POST", 
            redirect: 'follow',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Accept': 'application/json',
            },
            body: formData
        })
        .then(res => {
            if (res.ok) { // res.ok is true if status is 200-299
                return res.json().then(json => {
                    localStorage.clear();
                    localStorage.setItem('access_token', json.access_token);
                    localStorage.setItem('refresh_token', json.refresh_token);
                    localStorage.setItem('access_token_expires', json.access_token_expires);
                    localStorage.setItem('refresh_token_expires', json.refresh_token_expires);
                    localStorage.setItem('username', inputData.username)
                    localStorage.setItem('remember', inputData.remember_me)
                    // Add code to run if status is 200
                    window.location.href = afterLoginURL
                });
            } else {
                // Add code to run if status is not 200
                return res.json().then(json => {
                    setNotification(window.getServerResponse(json))
                });
            }
        })
    }

    return (
        <div style={{width: '100%', height: '100%', display: 'flex', flexDirection: 'column', backgroundColor: colors.backgroundColor}}>
            <Notification message={notification}></Notification>
            <div style={{width: '100%', height: '60px', borderBottom: '1px solid #e1e1e1', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center'}}>
                <div style={{width: '1000px', height: '100%', border: '0px solid black', display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                    <img onClick={() => props.setStage(0)} src={Logo} style={{height: '65%', cursor: 'pointer'}}></img>
                </div>
            </div>
            <div style={{width: '100%', borderRadius: '10px', flexGrow: 1, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center'}}>
                <div style={{width: '450px', height: '700px', backgroundColor: colors.backgroundColor, border: '0px solid black', display: 'flex', flexDirection: 'column', color: colors.fontColor, alignItems: 'flex-start'}}>
                    <span style={{fontSize: '32px', fontWeight: '600'}}>Login</span>
                    <span style={{fontWeight: '500', marginTop: '10px', fontFamily: ''}}>Hi, Welcome Back!</span>
                    {/*Google Block*/}
                    <div onClick={() => clickGoogle(data)} style={{width: '97.5%', height: '45px', border: '2px solid #e1e1e1', marginTop: '30px', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', borderRadius: '5px', cursor: 'pointer'}}>
                        <img src={Google} style={{height: '50%'}}></img>
                        <span style={{marginLeft: '20px', fontWeight: '600'}}>Login with Google</span>
                    </div>
                    <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', width: '100%', marginTop: '30px'}}>
                        <div style={{width: '100px', border: '1px solid #e1e1e1', marginLeft: '15px'}}></div>
                        <div style={{flexGrow: 1}}><span style={{color: colors.mutedColor}}>or Login with Email</span></div>
                        <div style={{width: '100px', border: '1px solid #e1e1e1', marginRight: '15px'}}></div>
                    </div>
                    {/*End Google Block*/}
                    <div style={{display: 'flex', flexDirection: 'column', width: '100%', alignItems: 'start', marginTop: '30px'}}>
                        <span style={{fontWeight: '500'}}>Email</span>
                        <input className="placeholder-color" placeholder='account@email.com' value={data.username} onChange={(e) => changeData(e.target.value, 'username')} style={{height: '40px', width: '97.5%', border: '2px solid #e1e1e1', marginTop: '10px', marginBottom: '30px', borderRadius: '5px', fontSize: '18px', paddingLeft: '10px', fontFamily: 'inter', backgroundColor: colors.backgroundColor, color: colors.fontColor}}></input>
                        <span stlye={{fontWeight: '500'}}>Password</span>
                        <input className="placeholder-color" placeholder='Enter your password' value={data.password} onChange={(e) => changeData(e.target.value, 'password')} type="password" style={{height: '40px', width: '97.5%', border: '2px solid #e1e1e1', marginTop: '10px', borderRadius: '5px', fontSize: '18px', paddingLeft: '10px', fontFamily: 'inter', backgroundColor: colors.backgroundColor, color: colors.fontColor}}></input>
                    </div>
                    <div className='noSelect' style={{width: '100%', display: 'flex', flexDirection: 'row', marginTop: '20px'}}>   
                        <div onClick={() => changeData(!data.remember_me, 'remember_me')} style={{display: 'flex', flexDirection: 'row', cursor: 'pointer', alignItems: 'center'}}>
                            <div style={{width: '16px', height: '16px', border: data.remember_me ? '2px solid ' + colors.primary:'2px solid #e1e1e1', backgroundColor: data.remember_me && colors.primary, borderRadius: data.remember_me && '5px'}}></div>
                            <span style={{marginLeft: '10px', fontWeight: '500'}}>Remember Me</span>
                        </div>
                        <span onClick={() => props.setStage(2)} style={{marginLeft: 'auto', color: colors.primary, fontWeight: '500', cursor: 'pointer'}}>Forgot Password?</span>
                    </div>
                    <button onClick={() => clickLogin(data)} style={{width: '100%', height: '50px', backgroundColor: colors.primary, borderRadius: '10px', marginTop: '30px', color: colors.primaryAccent, fontSize: '16px', fontFamily: 'inter', cursor: 'pointer', border: 'none'}}>Login</button>
                    <div style={{textAlign: 'center', width: '100%', marginTop: '30px'}}>
                        <span style={{color: colors.mutedColor}}>Not Registered Yet?</span>
                        <span onClick={() => props.setStage(3)} style={{color: colors.primary, fontWeight: '600', marginLeft: '20px', cursor: 'pointer'}}>Create an account</span>
                    </div>
                </div>
            </div>
            {/*Bunch of styling required here*/}
            <style>
                {`
                .placeholder-color::placeholder {
                    color: ${colors.mutedColor}; /* Change this to your desired color */
                }
                `}
            </style>
        </div>
    )
}

const ResetPage = (props) => {

    const [data, setData] = useState({
        password: '',
        password_confirm: '',
    })

    const [notification, setNotification] = useState('')

    const changeData = (value, key) => {
        setData((data) => ({...data, [key]: value}))
    }

    const changePassword = (inputData) => {
        var myHeaders = new Headers();
        myHeaders.append("Accept", "application/json");
        myHeaders.append("Authorization", "Bearer " + localStorage.getItem('access_token'));
        myHeaders.append("Content-Type", "application/json");
    
        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            redirect: 'follow',
            body: JSON.stringify({
                password: inputData.password,
            })
        }

        if (inputData.password !== inputData.password_confirm)
        {
            setNotification(getCurrentTimeFormatted() + ': Password do not match!')
            
        }
        else
        {
            window.apiRequest('/auth/reset_password/' + props.keyValue, requestOptions, (result, status) => {   
                if (status === 200)
                {
                    setNotification(getCurrentTimeFormatted() + ': Password changed successfully!')
                    window.location.assign(afterResetURL)
                } else {setNotification(window.getServerResponse(result))}
            })
        }
    }

    return (
        <div style={{width: '100%', height: '100%', display: 'flex', flexDirection: 'column', backgroundColor: colors.backgroundColor}}>
            <Notification message={notification}></Notification>
            <div style={{width: '100%', height: '60px', borderBottom: '1px solid #e1e1e1', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center'}}>
                <div style={{width: '1000px', height: '100%', border: '0px solid black', display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                    <img onClick={() => props.setStage(0)} src={Logo} style={{height: '65%', cursor: 'pointer'}}></img>
                </div>
            </div>
            <div style={{width: '100%', borderRadius: '10px', flexGrow: 1, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center'}}>
                <div style={{width: '450px', height: '700px', backgroundColor: colors.backgroundColor, border: '0px solid black', display: 'flex', flexDirection: 'column', color: colors.fontColor, alignItems: 'flex-start'}}>
                    <span style={{fontSize: '32px', fontWeight: '600'}}>Reset Password</span>
                    <span style={{fontWeight: '500', marginTop: '10px', fontFamily: ''}}>Please set your new password.</span>
                    <div style={{display: 'flex', flexDirection: 'column', width: '100%', alignItems: 'start', marginTop: '30px'}}>
                        <span style={{fontWeight: '500'}}>New Password</span>
                        <input className="placeholder-color" placeholder='account@email.com' value={data.password} onChange={(e) => changeData(e.target.value, 'password')} style={{height: '40px', width: '97.5%', border: '2px solid #e1e1e1', marginTop: '10px', marginBottom: '30px', borderRadius: '5px', fontSize: '18px', paddingLeft: '10px', fontFamily: 'inter', backgroundColor: colors.backgroundColor, color: colors.fontColor}}></input>
                        <span style={{fontWeight: '500'}}>Confirm New Password</span>
                        <input className="placeholder-color" placeholder='account@email.com' value={data.password_confirm} onChange={(e) => changeData(e.target.value, 'password_confirm')} style={{height: '40px', width: '97.5%', border: '2px solid #e1e1e1', marginTop: '10px', marginBottom: '30px', borderRadius: '5px', fontSize: '18px', paddingLeft: '10px', fontFamily: 'inter', backgroundColor: colors.backgroundColor, color: colors.fontColor}}></input>
                    </div>
                    <button onClick={() => changePassword(data)} style={{width: '100%', height: '50px', backgroundColor: colors.primary, borderRadius: '10px', marginTop: '30px', color: colors.primaryAccent, fontSize: '16px', fontFamily: 'inter'}}>Change Password</button>
                </div>
            </div>
            {/*Bunch of styling required here*/}
            <style>
                {`
                .placeholder-color::placeholder {
                    color: ${colors.mutedColor}; /* Change this to your desired color */
                }
                `}
            </style>
        </div>
    )
}

const ForgotPage = (props) => {

    if (props.keyValue)
    {
        props.setStage(1)
    }

    const [data, setData] = useState({
        email: '',
    })

    const [notification, setNotification] = useState('')

    const changeData = (value, key) => {
        setData((data) => ({...data, [key]: value}))
    }

    const resetPassword = (inputData) => {
        var myHeaders = new Headers();
        myHeaders.append("Accept", "application/json");
        myHeaders.append("Authorization", "Bearer " + localStorage.getItem('access_token'));
        myHeaders.append("Content-Type", "application/json");
    
        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            redirect: 'follow',
            body: JSON.stringify({
                email: inputData.email,
            })
        }

        window.apiRequest('/auth/forgot_password', requestOptions, (result, status) => {   
            if (status === 200)
            {
                setNotification(getCurrentTimeFormatted() + ': If this email exists, you will have received an email to reset your password.')
                setData({
                    email: '',
                 })
            } else {setNotification(window.getServerResponse(result))}
        })
    }

    return (
        <div style={{width: '100%', height: '100%', display: 'flex', flexDirection: 'column', backgroundColor: colors.backgroundColor}}>
            <Notification message={notification}></Notification>
            <div style={{width: '100%', height: '60px', borderBottom: '1px solid #e1e1e1', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center'}}>
                <div style={{width: '1000px', height: '100%', border: '0px solid black', display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                    <img onClick={() => props.setStage(0)} src={Logo} style={{height: '65%', cursor: 'pointer'}}></img>
                </div>
            </div>
            <div style={{width: '100%', borderRadius: '10px', flexGrow: 1, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center'}}>
                <div style={{width: '450px', height: '700px', backgroundColor: colors.backgroundColor, border: '0px solid black', display: 'flex', flexDirection: 'column', color: colors.fontColor, alignItems: 'flex-start'}}>
                    <span style={{fontSize: '32px', fontWeight: '600'}}>Forgot Password</span>
                    <span style={{fontWeight: '500', marginTop: '10px', fontFamily: ''}}>Please fill in your email to reset your password.</span>
                    <div style={{display: 'flex', flexDirection: 'column', width: '100%', alignItems: 'start', marginTop: '30px'}}>
                        <span style={{fontWeight: '500'}}>Email</span>
                        <input className="placeholder-color" placeholder='account@email.com' value={data.email} onChange={(e) => changeData(e.target.value, 'email')} style={{height: '40px', width: '97.5%', border: '2px solid #e1e1e1', marginTop: '10px', marginBottom: '30px', borderRadius: '5px', fontSize: '18px', paddingLeft: '10px', fontFamily: 'inter', backgroundColor: colors.backgroundColor, color: colors.fontColor}}></input>
                    </div>
                    <button onClick={() => resetPassword(data)} style={{width: '100%', height: '50px', backgroundColor: colors.primary, borderRadius: '10px', marginTop: '30px', color: colors.primaryAccent, fontSize: '16px', fontFamily: 'inter', border: 'none'}}>Reset Password</button>
                </div>
            </div>
            {/*Bunch of styling required here*/}
            <style>
                {`
                .placeholder-color::placeholder {
                    color: ${colors.mutedColor}; /* Change this to your desired color */
                }
                `}
            </style>
        </div>
    )
}

const CreateAccount = (props) => {

    if (props.keyValue)
    {
        props.setStage(1)
    }

    const [data, setData] = useState({
        email: '',
        password: '',
        password_confirm: '',
    })

    const [notification, setNotification] = useState('')

    const changeData = (value, key) => {
        setData((data) => ({...data, [key]: value}))
    }

    const createAccount = (inputData) => {

        var myHeaders = new Headers();
        myHeaders.append("Accept", "application/json");
        myHeaders.append("Authorization", "Bearer " + localStorage.getItem('access_token'));
        myHeaders.append("Content-Type", "application/json");
    
        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            redirect: 'follow',
            body: JSON.stringify({
                email: inputData.email,
                password: inputData.password,
            })
        };

        if (inputData.password === inputData.password_confirm)
        {
            window.apiRequest('/user', requestOptions, (result, status) => {   
                if (status === 200)
                {
                     setNotification(getCurrentTimeFormatted() + ': Account Created, an email has been sent to your email to verify your account.')
                     setData({
                        email: '',
                        password: '',
                        password_confirm: '',
                     })
                } else {setNotification(window.getServerResponse(result))}
            })
        }
        else
        {
            setNotification(getCurrentTimeFormatted() + ': Passwords do not match!')
        }
    }

    return (
        <div style={{width: '100%', height: '100%', display: 'flex', flexDirection: 'column', backgroundColor: colors.backgroundColor}}>
            <Notification message={notification}></Notification>
            <div style={{width: '100%', height: '60px', borderBottom: '1px solid #e1e1e1', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center'}}>
                <div style={{width: '1000px', height: '100%', border: '0px solid black', display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                    <img onClick={() => props.setStage(0)} src={Logo} style={{height: '65%', cursor: 'pointer'}}></img>
                </div>
            </div>
            <div style={{width: '100%', borderRadius: '10px', flexGrow: 1, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center'}}>
                <div style={{width: '450px', height: '700px', backgroundColor: colors.backgroundColor, border: '0px solid black', display: 'flex', flexDirection: 'column', color: colors.fontColor, alignItems: 'flex-start'}}>
                    <span style={{fontSize: '32px', fontWeight: '600'}}>Create Account</span>
                    <span style={{fontWeight: '500', marginTop: '10px', fontFamily: ''}}>Please fill in your details or sign in with Google</span>
                    {/*Google Block*/}
                    <div onClick={''} style={{width: '97.5%', height: '45px', border: '2px solid #e1e1e1', marginTop: '30px', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', borderRadius: '5px', cursor: 'pointer'}}>
                        <img src={Google} style={{height: '50%'}}></img>
                        <span style={{marginLeft: '20px', fontWeight: '600'}}>Login with Google</span>
                    </div>
                    <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', width: '100%', marginTop: '30px'}}>
                        <div style={{width: '100px', border: '1px solid #e1e1e1', marginLeft: '15px'}}></div>
                        <div style={{flexGrow: 1}}><span style={{color: colors.mutedColor}}>or Login with Email</span></div>
                        <div style={{width: '100px', border: '1px solid #e1e1e1', marginRight: '15px'}}></div>
                    </div>
                    {/*End Google Block*/}
                    <div style={{display: 'flex', flexDirection: 'column', width: '100%', alignItems: 'start', marginTop: '30px'}}>
                        <span style={{fontWeight: '500'}}>Email</span>
                        <input className="placeholder-color" placeholder='account@email.com' value={data.email} onChange={(e) => changeData(e.target.value, 'email')} style={{height: '40px', width: '97.5%', border: '2px solid #e1e1e1', marginTop: '10px', marginBottom: '30px', borderRadius: '5px', fontSize: '18px', paddingLeft: '10px', fontFamily: 'inter', backgroundColor: colors.backgroundColor, color: colors.fontColor}}></input>
                        <span stlye={{fontWeight: '500'}}>Password</span>
                        <input className="placeholder-color" placeholder='Enter your password' value={data.password} onChange={(e) => changeData(e.target.value, 'password')} type="password" style={{height: '40px', width: '97.5%', border: '2px solid #e1e1e1', marginBottom: '30px', marginTop: '10px', borderRadius: '5px', fontSize: '18px', paddingLeft: '10px', fontFamily: 'inter', backgroundColor: colors.backgroundColor, color: colors.fontColor}}></input>
                        <span stlye={{fontWeight: '500'}}>Confirm Password</span>
                        <input className="placeholder-color" placeholder='Enter your password' value={data.password_confirm} onChange={(e) => changeData(e.target.value, 'password_confirm')} type="password" style={{height: '40px', width: '97.5%', border: '2px solid #e1e1e1', marginTop: '10px', borderRadius: '5px', fontSize: '18px', paddingLeft: '10px', fontFamily: 'inter', backgroundColor: colors.backgroundColor, color: colors.fontColor}}></input>
                    </div>
                    <button onClick={() => createAccount(data)} style={{width: '100%', height: '50px', backgroundColor: colors.primary, borderRadius: '10px', marginTop: '30px', color: colors.primaryAccent, fontSize: '16px', fontFamily: 'inter', border: 'none'}}>Create Account</button>
                </div>
            </div>
            {/*Bunch of styling required here*/}
            <style>
                {`
                .placeholder-color::placeholder {
                    color: ${colors.mutedColor}; /* Change this to your desired color */
                }
                `}
            </style>
        </div>
    )
}

const SVG = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 2000 1500'%3E%3Crect fill='%23ffffff' width='2000' height='1500'/%3E%3Cdefs%3E%3Crect stroke='%23ffffff' stroke-width='0.6' width='1' height='1' id='s'/%3E%3Cpattern id='a' width='3' height='3' patternUnits='userSpaceOnUse' patternTransform='rotate(45 1000 750) scale(50) translate(-980 -735)'%3E%3Cuse fill='%23fcfcfc' href='%23s' y='2'/%3E%3Cuse fill='%23fcfcfc' href='%23s' x='1' y='2'/%3E%3Cuse fill='%23fafafa' href='%23s' x='2' y='2'/%3E%3Cuse fill='%23fafafa' href='%23s'/%3E%3Cuse fill='%23f7f7f7' href='%23s' x='2'/%3E%3Cuse fill='%23f7f7f7' href='%23s' x='1' y='1'/%3E%3C/pattern%3E%3Cpattern id='b' width='7' height='11' patternUnits='userSpaceOnUse' patternTransform='rotate(45 1000 750) scale(50) translate(-980 -735)'%3E%3Cg fill='%23f5f5f5'%3E%3Cuse href='%23s'/%3E%3Cuse href='%23s' y='5' /%3E%3Cuse href='%23s' x='1' y='10'/%3E%3Cuse href='%23s' x='2' y='1'/%3E%3Cuse href='%23s' x='2' y='4'/%3E%3Cuse href='%23s' x='3' y='8'/%3E%3Cuse href='%23s' x='4' y='3'/%3E%3Cuse href='%23s' x='4' y='7'/%3E%3Cuse href='%23s' x='5' y='2'/%3E%3Cuse href='%23s' x='5' y='6'/%3E%3Cuse href='%23s' x='6' y='9'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='h' width='5' height='13' patternUnits='userSpaceOnUse' patternTransform='rotate(45 1000 750) scale(50) translate(-980 -735)'%3E%3Cg fill='%23f5f5f5'%3E%3Cuse href='%23s' y='5'/%3E%3Cuse href='%23s' y='8'/%3E%3Cuse href='%23s' x='1' y='1'/%3E%3Cuse href='%23s' x='1' y='9'/%3E%3Cuse href='%23s' x='1' y='12'/%3E%3Cuse href='%23s' x='2'/%3E%3Cuse href='%23s' x='2' y='4'/%3E%3Cuse href='%23s' x='3' y='2'/%3E%3Cuse href='%23s' x='3' y='6'/%3E%3Cuse href='%23s' x='3' y='11'/%3E%3Cuse href='%23s' x='4' y='3'/%3E%3Cuse href='%23s' x='4' y='7'/%3E%3Cuse href='%23s' x='4' y='10'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='c' width='17' height='13' patternUnits='userSpaceOnUse' patternTransform='rotate(45 1000 750) scale(50) translate(-980 -735)'%3E%3Cg fill='%23f2f2f2'%3E%3Cuse href='%23s' y='11'/%3E%3Cuse href='%23s' x='2' y='9'/%3E%3Cuse href='%23s' x='5' y='12'/%3E%3Cuse href='%23s' x='9' y='4'/%3E%3Cuse href='%23s' x='12' y='1'/%3E%3Cuse href='%23s' x='16' y='6'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='d' width='19' height='17' patternUnits='userSpaceOnUse' patternTransform='rotate(45 1000 750) scale(50) translate(-980 -735)'%3E%3Cg fill='%23ffffff'%3E%3Cuse href='%23s' y='9'/%3E%3Cuse href='%23s' x='16' y='5'/%3E%3Cuse href='%23s' x='14' y='2'/%3E%3Cuse href='%23s' x='11' y='11'/%3E%3Cuse href='%23s' x='6' y='14'/%3E%3C/g%3E%3Cg fill='%23efefef'%3E%3Cuse href='%23s' x='3' y='13'/%3E%3Cuse href='%23s' x='9' y='7'/%3E%3Cuse href='%23s' x='13' y='10'/%3E%3Cuse href='%23s' x='15' y='4'/%3E%3Cuse href='%23s' x='18' y='1'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='e' width='47' height='53' patternUnits='userSpaceOnUse' patternTransform='rotate(45 1000 750) scale(50) translate(-980 -735)'%3E%3Cg fill='%23000000'%3E%3Cuse href='%23s' x='2' y='5'/%3E%3Cuse href='%23s' x='16' y='38'/%3E%3Cuse href='%23s' x='46' y='42'/%3E%3Cuse href='%23s' x='29' y='20'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='f' width='59' height='71' patternUnits='userSpaceOnUse' patternTransform='rotate(45 1000 750) scale(50) translate(-980 -735)'%3E%3Cg fill='%23000000'%3E%3Cuse href='%23s' x='33' y='13'/%3E%3Cuse href='%23s' x='27' y='54'/%3E%3Cuse href='%23s' x='55' y='55'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='g' width='139' height='97' patternUnits='userSpaceOnUse' patternTransform='rotate(45 1000 750) scale(50) translate(-980 -735)'%3E%3Cg fill='%23000000'%3E%3Cuse href='%23s' x='11' y='8'/%3E%3Cuse href='%23s' x='51' y='13'/%3E%3Cuse href='%23s' x='17' y='73'/%3E%3Cuse href='%23s' x='99' y='57'/%3E%3C/g%3E%3C/pattern%3E%3C/defs%3E%3Crect fill='url(%23a)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23b)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23h)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23c)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23d)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23e)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23f)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23g)' width='100%25' height='100%25'/%3E%3C/svg%3E")`

const Home = (props) => {

    const [stage, setStage] = useState(0)

    useEffect(() => {
        // Push the current stage to the history stack only if it is different from the current state
        const currentState = window.history.state;
        if (!currentState || currentState.stage !== stage) {
          window.history.pushState({ stage }, '');
        }
    
        // Listen for popstate event
        const handlePopState = (event) => {
          if (event.state) {
            setStage(event.state.stage);
          } else {
            setStage(0); // Default to the initial stage (login) if no state is found
          }
        };
    
        window.addEventListener('popstate', handlePopState);
    
        return () => {
          window.removeEventListener('popstate', handlePopState);
        };
      }, [stage]);
    
      const handleNavigation = (newStage) => {
        setStage(newStage);
        // Push the new stage to the history stack only if it is different from the current state
        const currentState = window.history.state;
        if (!currentState || currentState.stage !== newStage) {
          window.history.pushState({ stage: newStage }, '');
        }
    };

    const useQuery = () => {
        return new URLSearchParams(useLocation().search);
    };

    const query = useQuery();

    console.log(query.get('key'))

    const [resetPasswordKey, setResetPasswordKey] = useState(query.get('key'))

    //for triggering reset password modal
    useEffect(() => {
        const id = query.get('id');
        setResetPasswordKey(query.get('key'))
    },[])


    return (
        <div style={{width: '100vw', height: '100vh', backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', color: 'black'}}>
            {stage === 0 && <LoginPage stage={stage} setStage={handleNavigation} keyValue={resetPasswordKey}></LoginPage>}
            {stage === 1 && <ResetPage stage={stage} setStage={handleNavigation} keyValue={resetPasswordKey}></ResetPage>}
            {stage === 2 && <ForgotPage stage={stage} setStage={handleNavigation} keyValue={resetPasswordKey}></ForgotPage>}
            {stage === 3 && <CreateAccount stage={stage} setStage={handleNavigation} keyValue={resetPasswordKey}></CreateAccount>}
        </div>
    )
}

export default Home
